<template>
  <div class="SendGridList">
    <div class="container-fluid paddding-right-0px">
      <div class="table-responsive margin-Top-1Perc margin-left-0Point3Perc">
        <table class="table table-striped ">
          <thead>
           <tr>
              <th class="text-align-center font-size-15px border-right">{{getCurrentTab === 1? 'Date' : 'Sender'}}</th>
              <th class="text-align-center font-size-15px border-right">Processed</th>
              <th class="text-align-center font-size-15px border-right">Dropped</th>
              <th class="text-align-center font-size-15px border-right">Delivered</th>
              <th class="text-align-center font-size-15px border-right">Deferred</th>
              <th class="text-align-center font-size-15px border-right">Bounces</th>
              <th class="text-align-center font-size-15px border-right">Opens</th>
              <th class="text-align-center font-size-15px border-right">Clicks</th>
              <th class="text-align-center font-size-15px border-right">Spam Reports</th>
              <th class="text-align-center font-size-15px border-right">Unsubscribed</th>
              <th class="text-align-center font-size-15px border-right">Group Unsubscribes</th>
              <th class="text-align-center font-size-15px">Group Resubscribes</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(reportObj,index) in getReportList" :key="index" v-bind:reportObj = "reportObj">
               <td class="text-align-center text-valign-middle border-right col-lg-8 text-wrap">{{reportObj.StatDate}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Processed}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Dropped}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Delivered}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Deferred}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Bounces}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Opens}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Clicks}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.SpamReports}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.Unsubscribes}}</td>
               <td class="text-align-center text-valign-middle border-right col-lg-8">{{reportObj.GroupUnsubscribes}}</td>
               <td class="text-align-center text-valign-middle col-lg-8">{{reportObj.GroupResubscribes}}</td>
            </tr>
          </tbody>
       </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['responseObj', 'currentTab'],
  created: function () {},
  data: function () {
    return {}
  },
  methods: {},
  components: {},
  computed: {
    getReportList: {
      get: function () {
        return this.responseObj
      }
    },
    getCurrentTab: {
      get: function () {
        return parseInt(this.currentTab)
      }
    }
  },
  name: 'SendGridList'
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ManageGroup {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
  text-decoration: none;
} 
a:visited{
  color: #2c3e50;
  text-decoration: none;
}
a:hover {
  color: #2c3e50;
  text-decoration: none;
}
a:active {
  color: #2c3e50;
  text-decoration: none;
}
a{
  color: #2c3e50 !important;
}
.btn-text-color {
  color: #2c3e50;
}

.cursor-pointer {
  cursor: pointer;
}
.margin-left-2Point7Perc {
  margin-left: 2.7%;
}
.margin-right-1Point1Perc {
  margin-right: 1.1%;
}
.table > tbody > tr > td {
  padding: 1%;
}
 .margin-left-0Point3Perc
{
	margin-left: 0.3%;
}
.paddding-right-0px{
  padding-right:0%;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-wrap {
    /* width: 11em;  */
    /* border: 1px solid #000000; */
    word-wrap: break-word !important;
    /* text-align: justify; */
}
</style>


// WEBPACK FOOTER //
// src/components/reports/send_grid/SendGridList.vue